import React, { useState } from 'react';
import pluralize from 'pluralize';

import { APIdeleteAssetGroup } from '../../../api/Assets';

import type { AssetGroup } from '../../../types/asset-group';

interface AssetGroupDeleteModalProps {
  assetGroup: AssetGroup;
  show: boolean;
  onConfirm: (response: boolean) => void;
  onDismiss: () => void;
};

const AssetGroupDeleteModal: React.FC<AssetGroupDeleteModalProps> = ({ assetGroup, show, onConfirm, onDismiss }) => {
  const [saving, setSaving] = useState(false);

  const assetsCount = assetGroup.assets_count || 0;

  const handleDelete = async () => {
    setSaving(true);
    const response = await APIdeleteAssetGroup(assetGroup.id);
    if (response.status === 204) {
      onConfirm(true);
    } else {
      onConfirm(false);
    }
    setSaving(false);
  };

  return (
    <wa-dialog label="Delete image group" id="dialog-delete-asset-group" className="dialog-delete-user" open={show}>
      <div className="delete-user-header">
        <strong>Are you sure you want to delete the group "{assetGroup.name}"?</strong><br />
        This action cannot be undone.
      </div>
      <div className="delete-user-content wa-stack wa-gap-2">
        {assetsCount > 0 && (
          <wa-callout variant="danger" className="delete-user-warning">
            <i className="fa-regular fa-circle-exclamation" slot="icon"></i>
            <strong>This group has {pluralize('image', assetsCount, true)} assigned to it.</strong><br />
            The images will not be deleted, but they will be removed from this group.
          </wa-callout>
        )}
      </div>
      <wa-button
        slot="footer"
        size="s"
        appearance="outlined"
        onClick={() => onDismiss()}
      >
        Close
      </wa-button>
      <wa-button
        size="s"
        slot="footer"
        variant="brand"
        disabled={saving}
        onClick={handleDelete}
      >
        Delete group
      </wa-button>
    </wa-dialog>
  );
}

export default AssetGroupDeleteModal;
